import _ from 'lodash';

import createModel, { prop } from 'models/lib/create_model';
import IdGenerator from 'scripts/domain/contracts/id_generator';

const TaskComment = createModel({
  modelName: 'TaskComment',

  properties: {
    id: String,
    initiatingAgentId: String,
    itemId: String,
    createdAt: String,
    message: String,
    version: prop(Number).default(0),
  },

  statics: {
    create(attrs) {
      let defaults = {
        id: IdGenerator.newId(),
        createdAt: new Date().toISOString(),
      };
      return new this(_.merge({}, defaults, attrs));
    },
  },
});

export default TaskComment;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/task_comment.js